import { fetchAuth } from "../../../shared/common/api";

const json = async (res) => {
  const txt = await res.text();
  try { return txt ? JSON.parse(txt) : null; } catch { return txt; }
};

const okJson = async (res) => {
  if (!res.ok) throw new Error(`${res.status} ${await res.text().catch(() => "")}`);
  return json(res);
};

// context
export const apiMicrocycleContext = () => fetchAuth("/predictive/microcycle/context").then(okJson);

// protocol templates
export const apiListProtocols = () => fetchAuth("/predictive/protocol-templates").then(okJson);

// session templates
export const apiListSessionTemplates = () => fetchAuth("/predictive/session-templates").then(okJson);
export const apiGetSessionTemplate = (id) => fetchAuth(`/predictive/session-templates/${id}`).then(okJson);
export const apiSaveSessionTemplate = (payload) =>
  fetchAuth("/predictive/session-templates", { method: "POST", body: JSON.stringify(payload) }).then(okJson);
export const apiDeleteSessionTemplate = (id) =>
  fetchAuth(`/predictive/session-templates/${id}`, { method: "DELETE" }).then(okJson);

// microcycle templates
export const apiListMicrocycles = () => fetchAuth("/predictive/microcycle-templates").then(okJson);
export const apiGetMicrocycle = (id) => fetchAuth(`/predictive/microcycle-templates/${id}`).then(okJson);
export const apiSaveMicrocycle = (payload) =>
  fetchAuth("/predictive/microcycle-templates", { method: "POST", body: JSON.stringify(payload) }).then(okJson);
export const apiDeleteMicrocycle = (id) =>
  fetchAuth(`/predictive/microcycle-templates/${id}`, { method: "DELETE" }).then(okJson);
export const apiDeactivateScenario = (id) =>
  fetchAuth(`/predictive/microcycle-templates/${id}/deactivate`, { method: "POST" }).then(okJson);
export const apiCleanupExpiredScenarios = () =>
  fetchAuth("/predictive/microcycle-templates/cleanup-expired", { method: "POST" }).then(okJson);

// runs
export const apiCreateRun = (payload) =>
  fetchAuth("/predictive/runs", { method: "POST", body: JSON.stringify(payload) }).then(okJson);
export const apiLaunchRun = (payload) =>
  fetchAuth("/predictive/runs/launch", { method: "POST", body: JSON.stringify(payload) }).then(okJson);
export const apiGetRun = (id) => fetchAuth(`/predictive/runs/${id}`).then(okJson);
export const apiGetRunResults = (id) => fetchAuth(`/predictive/runs/${id}/results`).then(okJson);
export const apiDeactivateRun = (id) =>
  fetchAuth(`/predictive/runs/${id}/deactivate`, { method: "POST" }).then(okJson);
export async function apiListRuns() {
  const res = await fetchAuth("/predictive/runs");
  if (!res.ok) {
    return [];
  }

  const data = await res.json();
  const runs = Array.isArray(data) ? data : (data?.runs || []);

  return runs;
}

// calendar event update (sync microcycle sessions with global calendar)
export const apiUpdateCalendarEvent = (season, payload) =>
  fetchAuth(`/calendar/event?season=${encodeURIComponent(season)}`, { 
    method: "POST", 
    body: JSON.stringify(payload) 
  }).then(okJson);

// calendar event delete (remove from global calendar)
export const apiDeleteCalendarEvent = (season, { date, period }) =>
  fetchAuth(`/calendar/event?season=${encodeURIComponent(season)}`, { 
    method: "POST", 
    body: JSON.stringify({ date, period, action: "remove" }) 
  }).then(okJson);

// calendar microcycle (get current microcycle window from club calendar)
export const apiGetCalendarMicrocycle = async ({ season, from } = {}) => {
  const qs = new URLSearchParams();
  if (season) qs.set("season", season);
  if (from) qs.set("from", from);
  return fetchAuth(`/microcycle?${qs.toString()}`).then(okJson);
};

// list all match-based microcycles from club calendar
export const apiListMicrocyclesByMatch = async ({ season } = {}) => {
  const qs = new URLSearchParams();
  if (season) qs.set("season", season);
  return fetchAuth(`/microcycle/list?${qs.toString()}`).then(okJson);
};

// get a specific microcycle by target match date
export const apiGetMicrocycleByMatch = async ({ season, match_date } = {}) => {
  const qs = new URLSearchParams();
  if (season) qs.set("season", season);
  if (match_date) qs.set("match_date", match_date);
  return fetchAuth(`/microcycle/by-match?${qs.toString()}`).then(okJson);
};

export const apiGetRunInputs = (id) =>
  fetchAuth(`/predictive/runs/${id}/inputs`).then(okJson);

export const apiResolveRun = (payload) =>
  fetchAuth("/predictive/runs/resolve", { method: "POST", body: JSON.stringify(payload) }).then(okJson);


export const apiGetPlayerReferences = () =>
  fetchAuth("/predictive/player-references").then(okJson);

export const apiMatchProtocolPlayer = (payload) =>
  fetchAuth("/predictive/protocol-player/match", {
    method: "POST",
    body: JSON.stringify(payload),
  }).then(okJson);

// Maquette demo: forced results for demo club
export const apiGetMaquetteDemo = () =>
  fetchAuth("/predictive/maquette-demo").then(okJson);
